import { render, staticRenderFns } from "./TheCallHistoryItem.vue?vue&type=template&id=ba2698de&scoped=true"
import script from "./TheCallHistoryItem.vue?vue&type=script&lang=js"
export * from "./TheCallHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./TheCallHistoryItem.vue?vue&type=style&index=0&id=ba2698de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2698de",
  null
  
)

export default component.exports